module.exports = __webpack_public_path__ + "images/help/road@2x-16ba5a473347304e6c4c79000e164591.png";